var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 8,
    fill: "#828282"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.087 18.9789C29.071 19.0216 27.1896 18.4231 25.5768 17.3114V24.9649C25.5768 27.8723 23.6954 30.4377 20.8283 31.4638C18.0061 32.49 14.7807 31.7204 12.8097 29.5397C10.7938 27.3165 10.4354 24.1953 11.8689 21.6298C13.3024 19.1072 16.259 17.6962 19.3053 18.081V21.9291C17.9165 21.5016 16.3934 21.9719 15.5423 23.0836C14.7359 24.2379 14.7359 25.7345 15.5871 26.8462C16.4382 27.9578 17.9613 28.4282 19.3053 28.0005C20.694 27.573 21.6347 26.333 21.6347 24.9649V10H25.5768C25.5768 10.3421 25.5768 10.6413 25.6665 10.9834C25.9352 12.3944 26.7864 13.6343 28.0855 14.4039C28.9367 14.9598 30.0118 15.2591 31.087 15.2591V18.9789Z",
    fill: "#262627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokBlack);
export default __webpack_public_path__ + "static/media/tiktokBlack.0f859b574f150b9ac4f552ce36cb1f31.svg";
export { ForwardRef as ReactComponent };